var Cortona3DSolo = require('solo');
var Tiramisu = Module.Tiramisu;
var app = require('app').app;
var expand = require('lib/util').expand;

// Tiramisu hooks
expand(Tiramisu, {
    procedure: {
        didFireEvent: function (type, id, title, info) {
            Cortona3DSolo.dispatch('app.procedure.didFireEvent', type, id, title, info);
        },
        didChangePlayerState: function (position, state) {
            Cortona3DSolo.dispatch('app.procedure.didChangePlayerState', position, state);
        },
        didEnterSubstep: function (substepPath) {
            Cortona3DSolo.dispatch('app.procedure.didEnterSubstep', substepPath);
        },
        didEnterSubstepWithName: function (substepId) {
            Cortona3DSolo.dispatch('app.procedure.didEnterSubstepWithName', substepId);
        }
    },
});

function allocCString(str) {
    var length = lengthBytesUTF8(str) + 1;
    var sz = _malloc(length);
    stringToUTF8(str, sz, length);
    return sz;
}

var appExports = {
    /**
     * The namespace represents an application interface to manage interactive procedure.
     *  
     * @namespace
     * @memberof module:solo.app
     */
    procedure: {
        /**
         * The duration of the interactive procedure in seconds.
         * 
         * @static
         * @member {number} duration
         * @memberof module:solo.app.procedure
         * @since 1.4.3
         */

        /**
         * Gets or sets default seek mode.
         * 
         * @static
         * @member {ProcedureSeekMode} defaultSeekMode
         * @memberof module:solo.app.procedure
         * @since 1.5.3
         */

        /**
         * Moves the playback marker of the procedure to the start of the specified step/substep.
         * 
         * @param {string} id - Step/Substep ID
         * @param {ProcedureSeekMode} [seekMode=SEEK_DEFAULT]
         */
        seekToSubstep: function (id, seekMode) {
            Module.ccall('procedure_seekToSubstep', 'null', ['string', 'number'], [id, typeof (seekMode) === 'number' ? seekMode : -1]);
        },

        /**
         * Sets the playback speed ratio.
         * 
         * @param {number} playbackSpeed - The playback speed ratio
         */
        setPlaybackSpeed: function (playbackSpeed) {
            Module.ccall('procedure_setPlaybackSpeed', 'null', ['number'], arguments);
        },

        /**
         * Specifies whether the camera position is changed during the playback of the procedure. 
         * 
         * @param {boolean} freezeCamera
         * - `true` - the camera does not change
         * - `false` - the camera position is changed in accordance with the procedure 
         */
        freezeCamera: function (freezeCamera) {
            Module.ccall('procedure_freezeCamera', 'null', ['number'], arguments);
        },

        /**
         * Sets a new playback position of the procedure.
         * 
         * @param {number} playPosition - The playback marker position, in seconds
         * @param {boolean} requestState - 
         * - `true` - request {@link module:solo.app.procedure.didEnterSubstep didEnterSubstep()} callbak after position is changed
         * - `false` - a callback is not required
         */
        setPlayPosition: function (playPosition, requestState) {
            Module.ccall('procedure_setPlayPosition', 'null', ['number', 'number'], arguments);
        },

        /**
         * Move the playback marker position to the previous step.
         * @param {ProcedureSeekMode} [seekMode=SEEK_DEFAULT]
         */
        backward: function (seekMode) {
            Module.ccall('procedure_backward', 'null', ['number'], [typeof (seekMode) === 'number' ? seekMode : -1]);
        },

        /**
         * Move the playback marker position to the next step.
         * @param {ProcedureSeekMode} [seekMode=SEEK_DEFAULT]
         */
        forward: function (seekMode) {
            Module.ccall('procedure_forward', 'null', ['number'], [typeof (seekMode) === 'number' ? seekMode : -1]);
        },

        /**
         * Stops the playback of the procedure.
         */
        stop: function () {
            Module.ccall('procedure_stop', 'null');
        },

        /**
         * Starts the playback of the procedure.
         * 
         * @param {boolean} [doNotAutoRewind=false] -
         * - `true` - do not set the playback marker at the beginning of the procedure when the procedure is finished running
         * - `false` - reset the playback to the beginning
         */
        play: function (doNotAutoRewind) {
            Module.ccall('procedure_play', 'null', ['number'], arguments);
        },

        /**
         * Pauses the playback of the procedure.
         */
        pause: function () {
            Module.ccall('procedure_pause', 'null');
        },

        /**
         * Sets the playback range of the procedure on the timeline.
         * 
         * @param {string|ProcedureRangeKeyword} firstPlayable - Step/substep ID or the keyword of the range
         * @param {string|ProcedureRangeKeyword} lastPlayable - Step/substep ID or the keyword of the range
         * @param {ProcedureRangeFlags} [flags=0] - Flags bitmask
         * @see Properties in the {@link module:solo.app.procedure app.procedure} namespace
         * @fires "app.procedure.didChangePlayRange"
         */
        setPlayRange: function (firstPlayable, lastPlayable, flags) {
            Module.ccall('procedure_setPlayRange', 'null', ['string', 'string', 'number'], [firstPlayable, lastPlayable || firstPlayable, flags || 0]);
            Cortona3DSolo.dispatch('app.procedure.didChangePlayRange', Module._procedure_getPlayableRangeStartTime(), Module._procedure_getPlayableRangeStopTime());
        },

        /**
         * Returns the playable range start time. 
         * 
         * @returns {number} seconds  
         */
        getPlayableRangeStartTime: function () {
            return Module.ccall('procedure_getPlayableRangeStartTime', 'number');
        },

        /**
         * Returns the playable range stop time. 
         * 
         * @returns {number} seconds  
         */
        getPlayableRangeStopTime: function () {
            return Module.ccall('procedure_getPlayableRangeStopTime', 'number');
        },

        /**
         * Query the state of the procedure playback and its current step.
         */
        requestPlayerState: function () {
            Module.ccall('procedure_requestPlayerState', 'null');
        },

        /**
         * Returns the procedure options from the companion file *.interactivity.xml* in the form of an object with key/value pairs.
         * 
         * @deprecated Use {@link module:solo.app.getOptions app.getOptions()} istead.
         * @returns {KeyValuePairs}
         */
        getOptions: function () {
            return app.getOptions();
        },

        /**
         * Returns the value of the procedure option.
         * 
         * @deprecated Use {@link module:solo.app.getOption app.getOption()} istead.
         * @param {string} name - Option name
         * @returns {string} Option value
         */
        getOption: function (name) {
            return app.getOption(name);
        },

        /**
         * Sets the new animation sequence (procedure) from the array of identifiers step/substep.
         * 
         * @param {string[]} [items] Array of identifiers step/substep. Leave empty to restore the procedure to its original sequence.
         * @returns {boolean} Success flag
         * @since 1.4.3
         * @fires "app.procedure.didChangePlayableItemList"
         */
        setPlayableItemList: function (items) {
            var count = items ? items.length : 0;
            var itemArray = count ? _malloc(count * 4) : 0;
            for (var i = 0, j = itemArray >>> 2; i < count; ++i, ++j)
                HEAPU32[j] = allocCString(items[i]);
            var res = Module._procedure_setPlayableItemList(itemArray, count);
            for (var i = 0, j = itemArray >>> 2; i < count; ++i, ++j)
                _free(HEAPU32[j]);
            _free(itemArray);
            if (res) {
                Cortona3DSolo.dispatch('app.procedure.didChangePlayableItemList', Module._procedure_getDuration(), items);
            }
            return res !== 0;
        }
    }
};

Object.defineProperty(appExports.procedure, 'defaultSeekMode', {
    get: function () {
        return Module._procedure_getDefaultSeekMode();
    },
    set: function (mode) {
        Module._procedure_setDefaultSeekMode(mode);
    },
    enumerable: true,
    configurable: true
});

Object.defineProperty(appExports.procedure, 'duration', {
    get: function () {
        return Module._procedure_getDuration();
    },
    enumerable: true,
    configurable: true
});

Object.defineProperty(appExports.procedure, 'RANGE_FLAGS_SEEK_TO_START', {
    value: 1,
    writable: false
});
Object.defineProperty(appExports.procedure, 'RANGE_FLAGS_SEEK_TO_END', {
    value: 2,
    writable: false
});
Object.defineProperty(appExports.procedure, 'RANGE_FLAGS_REQUEST_NOTIFICATION', {
    value: 4,
    writable: false
});
Object.defineProperty(appExports.procedure, 'RANGE_FLAGS_DO_NOT_RECALCULATE_POSITION', {
    value: 8,
    writable: false
});

Object.defineProperty(appExports.procedure, 'SEEK_DEFAULT', {
    value: -1,
    writable: false
});
Object.defineProperty(appExports.procedure, 'SEEK_TO_BEGIN', {
    value: 0,
    writable: false
});
Object.defineProperty(appExports.procedure, 'SEEK_TO_CUE_POINT', {
    value: 1,
    writable: false
});
Object.defineProperty(appExports.procedure, 'SEEK_TO_END', {
    value: 2,
    writable: false
});


Object.defineProperty(appExports.procedure, 'RANGE_VALUE_CURRENT_STEP', {
    value: '%%CURRENT_STEP%%',
    writable: false
});
Object.defineProperty(appExports.procedure, 'RANGE_VALUE_CURRENT_SUBSTEP', {
    value: '%%CURRENT_SUBSTEP%%',
    writable: false
});

module.exports = {
    app: appExports
};

/**
 * The hook method is invoked when the alert message is fired in the procedure.
 * 
 * @memberof module:solo.app.procedure
 * @abstract 
 * @function didFireEvent
 * @param {string} type - Type of alert:
 * - `"WARNING"` 
 * - `"CAUTION"`
 * - `"NOTE"`
 * - custom alert type
 * @param {string} id - Alert message ID from interactivity.xml
 * @param {string} title - Alert message title
 * @param {string} info - Alert message text
 * @see The corresponding event {@link event:"app.procedure.didFireEvent" "app.procedure.didFireEvent"}
 */
/**
 * @event "app.procedure.didFireEvent"
 * @see The corresponding hook method {@link module:solo.app.procedure.didFireEvent app.procedure.didFireEvent()}
 */

/**
 * The hook method is invoked when the alert message is fired in the procedure.
 * 
 * @memberof module:solo.app.procedure
 * @abstract 
 * @function willShowNotification
 * @param {string} type - Type of alert:
 * - `"WARNING"` 
 * - `"CAUTION"`
 * - `"NOTE"`
 * - custom alert type
 * @param {string} text - Alert message text
 * @see The corresponding event {@link event:"app.procedure.willShowNotification" "app.procedure.willShowNotification"}
 */
/**
 * @event "app.procedure.willShowNotification"
 * @see The corresponding hook method {@link module:solo.app.procedure.willShowNotification app.procedure.willShowNotification()}
 */

/**
 * The hook method is invoked when the state of the procedure is changed.
 * 
 * @memberof module:solo.app.procedure
 * @abstract 
 * @function didChangePlayerState
 * @param {number} position - Current playback position on the timeline (seconds)
 * @param {number} state - Current procedure state as a bitmask
 * 
 * Flags bitmask:
 * - `0x001` - procedure is played
 * - `0x100` - fast forward is available
 * - `0x200` - rewind is available
 * - `0x400` - sound is played in the 3D procedure
 * @see The corresponding event {@link event:"app.procedure.didChangePlayerState" "app.procedure.didChangePlayerState"}
 */
/**
 * @event "app.procedure.didChangePlayerState"
 * @see The corresponding hook method {@link module:solo.app.procedure.didChangePlayerState app.procedure.didChangePlayerState()}
 */

/**
 * The hook method is invoked when the playback of the next substep starts.
 * 
 * > #### __NOTE__
 * >
 * > This method is called only for the steps/substeps with a non-empty comment field.
 * 
 * @memberof module:solo.app.procedure
 * @abstract 
 * @function didEnterSubstep
 * @param {string[]} substepPath - An array of step/substep ID contains current substep and its ancestors
 * @see The corresponding event {@link event:"app.procedure.didEnterSubstep" "app.procedure.didEnterSubstep"}
 */
/**
 * @event "app.procedure.didEnterSubstep"
 * @see The corresponding hook method {@link module:solo.app.procedure.didEnterSubstep app.procedure.didEnterSubstep()}
 */

/**
 * The hook method is invoked when the playback of the substep with substepId is starting.    
 * 
 * @memberof module:solo.app.procedure
 * @abstract 
 * @function didEnterSubstepWithName
 * @param {string} substepId - Substep ID
 * @see The corresponding event {@link event:"app.procedure.didEnterSubstepWithName" "app.procedure.didEnterSubstepWithName"}
 */
/**
 * @event "app.procedure.didEnterSubstepWithName"
 * @see The corresponding hook method {@link module:solo.app.procedure.didEnterSubstepWithName app.procedure.didEnterSubstepWithName()}
 */

/**
* The hook method is invoked when the list of playable items in the procedure is changed successfully.
* 
* @memberof module:solo.app.procedure
* @abstract 
* @function didChangePlayableItemList
* @param {number} duration - The duration of the new procedure
* @param {string[]} [items] Array of identifiers step/substep
* @see The corresponding event {@link event:"app.procedure.didChangePlayableItemList" "app.procedure.didChangePlayableItemList"}
* @see {@link module:solo.app.procedure.setPlayableItemList app.procedure.setPlayableItemList()}
* @since 1.7.0
*/
/**
 * @event "app.procedure.didChangePlayableItemList"
 * @see The corresponding hook method {@link module:solo.app.procedure.didChangePlayableItemList app.procedure.didChangePlayableItemList()}
 */

/**
 * The hook method is invoked when the play range of the procedure is changed.
 * 
 * @memberof module:solo.app.procedure
 * @abstract 
 * @function didChangePlayRange
 * @param {number} startPosition - The start time of the play range
 * @param {number} endPosition - The end time of the play range
 * @see The corresponding event {@link event:"app.procedure.didChangePlayRange" "app.procedure.didChangePlayRange"}
 * @see {@link module:solo.app.procedure.setPlayRange app.procedure.setPlayRange()}
 * @since 1.7.0
 */
/**
 * @event "app.procedure.didChangePlayRange"
 * @see The corresponding hook method {@link module:solo.app.procedure.didChangePlayRange app.procedure.didChangePlayRange()}
 */


/**
 * Procedure playback range flags.
 * @prop {number} app.procedure.RANGE_FLAGS_SEEK_TO_START=1
 * @prop {number} app.procedure.RANGE_FLAGS_SEEK_TO_END=2
 * @prop {number} app.procedure.RANGE_FLAGS_REQUEST_NOTIFICATION=4
 * @prop {number} app.procedure.RANGE_FLAGS_DO_NOT_RECALCULATE_POSITION=8
 * @typedef {number} ProcedureRangeFlags
 * @see {@link module:solo.app.procedure.setPlayRange app.procedure.setPlayRange()}
 */

/**
 * Procedure playback range constants.
 * @prop {string} app.procedure.RANGE_VALUE_CURRENT_STEP=%%CURRENT_STEP%%
 * @prop {string} app.procedure.RANGE_VALUE_CURRENT_SUBSTEP=%%CURRENT_SUBSTEP%%
 * @typedef {number} ProcedureRangeKeyword
 * @see {@link module:solo.app.procedure.setPlayRange app.procedure.setPlayRange()}
 */

/**
 * Seek mode constants.
 * @prop {number} app.procedure.SEEK_DEFAULT=-1
 * @prop {number} app.procedure.SEEK_TO_BEGIN=0
 * @prop {number} app.procedure.SEEK_TO_CUE_POINT=1 The __setViewpoint__ command is skipped (if any) at the beginning of the substep when calculating seek position.
 * @prop {number} app.procedure.SEEK_TO_END=2
 * @typedef {number} ProcedureSeekMode
 * @see {@link module:solo.app.procedure.forward app.procedure.forward()}
 * @see {@link module:solo.app.procedure.backward app.procedure.backward()}
 * @see {@link module:solo.app.procedure.seekToSubstep app.procedure.seekToSubstep()}
 * @since 1.5.3
 */